import { useState } from 'react'
import { type ToastContentProps } from 'react-toastify'
import { ActionToast } from '@opallabs/lapidary'
import type {
  SupportedResource,
  ResourceMeta,
  ResourceShareParams,
} from '../../types'

type ResourcePrivacyToastProps<ResourceType extends SupportedResource> = {
  resourceMeta: ResourceMeta<ResourceType>
  resourceShareParams: ResourceShareParams<ResourceType>
}

export const ResourcePrivacyToast = <ResourceType extends SupportedResource>({
  resourceMeta,
  resourceShareParams,
  ...toastProps
}: ResourcePrivacyToastProps<ResourceType> & ToastContentProps<unknown>) => {
  const [isCopied, setCopied] = useState(false)

  const copyText = () => {
    const shareUrl = resourceMeta.getShareUrl(resourceShareParams)
    setCopied(true)
    navigator.clipboard.writeText(shareUrl)
  }

  return (
    <ActionToast
      {...toastProps}
      onActionClick={copyText}
      actionText={isCopied ? 'Copied!' : 'Copy Link'}
      actionType="primary"
      title="Share Settings Saved"
    />
  )
}
